import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { PartnerLiquidationsService } from '../services/partner-liquidations';
import { PartnerLiquidationListItem } from '../../../shared/models/partner-liquidation-list-item';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-liquidations',
    standalone: true,
    imports: [CommonModule, MatTableModule, MatSortModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule],
    templateUrl: './liquidations.html',
    styleUrl: './liquidations.css'
})
export class Liquidations implements OnInit, AfterViewInit {
    dataSource: MatTableDataSource<PartnerLiquidationListItem> = new MatTableDataSource<PartnerLiquidationListItem>([]);

    displayedColumns: string[] = [
        'week',
        'year',
        'month',
        'totalToInvoice',
        'totalToDeposit',
        'status',
        'createdAt',
        'actions'
    ];

    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatPaginator) paginator!: MatPaginator;

    private statusTranslations: { [key: string]: string } = {
        'PENDING_UPLOAD'     : 'Pendiente de documentos',
        'REVIEW_IN_PROGRESS' : 'En revisión',
        'REJECTED'           : 'Rechazada',
        'APPROVED'           : 'Aprobada'
    };

    constructor(private partnerLiquidationsService: PartnerLiquidationsService, private router: Router) {
        this.dataSource.filterPredicate = (data: PartnerLiquidationListItem, filter: string) => {
            const searchString = filter.trim().toLowerCase();
            const weekMatch = data.week.toString().toLowerCase().includes(searchString);
            const yearMatch = data.year.toString().toLowerCase().includes(searchString);

            return weekMatch || yearMatch;
        };
    }

    ngOnInit(): void {
        this.loadLiquidations();
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    getTranslatedStatus(status: string): string {
        return this.statusTranslations[status] || status;
    }

    async loadLiquidations(): Promise<void> {
        const data = await this.partnerLiquidationsService.getPartnerLiquidations();
        this.dataSource.data = data || [];
    }

    applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if(this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    goToDetail(liq: PartnerLiquidationListItem): void {
        this.router.navigate(['/liquidations', liq.id]);
    }
}
